export default __webpack_public_path__ + "static/share-45d11a008e3f18e4c65f951c77f945fe.jpg";